import React from 'react';
import PropTypes from 'prop-types';
import AoswSignInWidget from './login-experience/aosw/AoswSignInWidget';
import CommonLoginIdentityWidget from './login-experience/common-login-identity/CommonLoginIdentityWidget';
import {
  getCommonLoginIdentitySpaRolloutTarget,
  getCommonLoginIdentitySpaPage,
  LOGIN_UI
} from './login-experience/common-login-identity-spa-rollout';
import sessionStorageUtil from './lib/session-storage-util';
import { logCommonLoginIdentitySpaRolloutDecision } from './lib/amplitude-utils';

/**
 * Renders the patient login workflow pages with either the legacy AOSW widget or
 * common-login-identity-spa, picked once per mount by common-login-identity-spa-rollout.js.
 *
 * The two experiences share nothing below this switch. To retire AOSW: delete
 * login-experience/aosw/ and common-login-identity-spa-rollout.js, then render
 * CommonLoginIdentityWidget here directly.
 */
export default function OktaSignInWidget({
  commonLoginIdentityInputs,
  commonLoginIdentitySpaRollout,
  ...postAuthnConfigs
}) {
  const [rolloutDecision] = React.useState(() => {
    const page = getCommonLoginIdentitySpaPage({
      hash: window.location.hash,
      originalAuthorizeUrl: sessionStorageUtil.getOriginalAuthUrl(),
    });
    return {
      page,
      target: getCommonLoginIdentitySpaRolloutTarget({
        commonLoginIdentitySpaRollout,
        page,
      }),
    };
  });

  React.useEffect(() => {
    logCommonLoginIdentitySpaRolloutDecision({
      rollout_target: rolloutDecision.target,
      page: rolloutDecision.page || 'legacy-page',
    });
  }, [rolloutDecision]);

  if (rolloutDecision.target === LOGIN_UI.COMMON_LOGIN_IDENTITY_SPA) {
    return <CommonLoginIdentityWidget {...postAuthnConfigs} commonLoginIdentityInputs={commonLoginIdentityInputs} />;
  }
  return <AoswSignInWidget {...postAuthnConfigs} />;
}

OktaSignInWidget.propTypes = {
  commonLoginIdentitySpaRollout: PropTypes.bool,
  // Values only the new SPA needs, kept outside postAuthnConfigs so AOSW's props are unchanged.
  commonLoginIdentityInputs: PropTypes.shape({
    emailToken: PropTypes.string,
  }),
};
